import {EventEmitter, Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {upsertEntityConfig} from '~entity/entity-configuracao/entity-configuracao.actions';
import {EntityConfiguracao, entityConfigVoid} from '~entity/entity-configuracao/entity-configuracao.model';
import {entityConfigSelectAll, entityConfigSelectById, entityConfigCamposVisiveis} from '~entity/entity-configuracao/entity-configuracao.selectors';
import {ParametrosVo} from '~model/vo/parametros-vo';
import {TiposIncidentesVo} from '~model/vo/tipos-incidentes-vo';
import {EntityIndicador} from '~entity/entity-indicador/entity-indicador.model';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ConfiguracoesService} from '~core/api/configuracoes.service';
import {LSItem} from '~utils/storage-utils';
import {setLogo} from '~feature/feature-app/feature-app.actions';

@Injectable({providedIn: 'root'})
export class AppConfigService {
  private config?: EntityConfiguracao;

  constructor(
    private store: Store,
    private configService: ConfiguracoesService
  ) {
    store.select(entityConfigSelectById(this.empresa)).subscribe(res => this.config = res);
  }

  atualizaConfiguracoes(emitter?: EventEmitter<EntityConfiguracao>): void {
    const defaultLocation: [number, number] = [-47.165451, -22.847815];
    this.configService.getConfiguracoes().subscribe(res => {
      console.log('[AppConfigService] Retorno API getConfiguracoes:', res);
      console.log('[AppConfigService] camposGrid da API:', res.camposGrid);
      if (!res.camposVisiveis) {
        res.camposVisiveis = [];
      }
      if (!res.filtrosVisiveis) {
        res.filtrosVisiveis = [];
      }
      this.store.dispatch(upsertEntityConfig({
        entity: {
          ...res,
          id: this.empresa,
          defaultLocation,
          camposGrid: (res.camposGrid?.length ?? 0) > 0 ? res.camposGrid : ['placa', 'nomeRota', 'identificador'],
        },
      }));
      this.store.dispatch(setLogo({ logo: res.parametros.linkLogo ?? '' }));
      emitter?.emit(res);
    });
  }

  getConfiguracao(): EntityConfiguracao {
    return this.config || entityConfigVoid();
  }

  getParametro(): ParametrosVo {
    return this.getConfiguracao().parametros;
  }

  getIncidentes(): TiposIncidentesVo {
    return this.getConfiguracao().tiposIncidentes;
  }

  getIndicador(id: string): EntityIndicador {
    return this.getConfiguracao().configIndicadores.indicadores[id];
  }

  getFiltrosVisiveis(): string[] {
    return this.getConfiguracao().filtrosVisiveis;
  }

  selectFiltrosVisiveis(): Observable<string[] | null> {
    return this.store.select(entityConfigSelectAll).pipe(
      map(entities => {
        const e = entities.find(ent => ent.id === this.empresa);
        if (!e) return null;
        if (e.personalizarFiltros === false) return null;
        return e.filtrosVisiveis ?? [];
      })
    );
  }

  selectConfigCarregado(): Observable<boolean> {
    return this.store.select(entityConfigSelectAll).pipe(map(entities => entities.length > 0));
  }

  selectCamposVisiveis(): Observable<string[]> {
    return this.store.select(entityConfigCamposVisiveis(this.empresa));
  }

  getCamposVisiveis(): string[] {
    return this.getConfiguracao().camposVisiveis;
  }

  getMostraIndicadores(): boolean {
    return this.getConfiguracao().mostrarIndicadores;
  }

  getAtivaTratativasIncidentes(): boolean {
    return this.getConfiguracao().parametros.ativaTratativasIncidentes;
  }

  get empresa(): string {
    return localStorage.getItem(LSItem.empresa) ?? '';
  }
}
